<template>
  <v-card
    flat
    tile
    :ripple="{ class: 'primary--text' }"
    class="d-flex justify-space-between align-center py-2 pl-4"
    @click="handleSwitch"
    @keydown.enter="handleSwitch"
  >
    <div class="d-flex align-center">
      <v-icon
        class="mr-4"
        color="icon-secondary"
      >
        ui-icon-rating-star-outline
      </v-icon>
      <div class="d-flex flex-column align-start">
        <div class="text-body-1 text--text">
          {{ t('Высокий рейтинг', options) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          {{ t('С рейтингом выше 4.0', options) }}
        </div>
      </div>
    </div>
    <v-switch
      :value="filtersStore.unsavedFilters.isHighRating"
      :input-value="filtersStore.unsavedFilters.isHighRating"
      color="primary"
      class="pt-0 mt-0 pl-1"
      hide-details
      dense
      inset
      @input="emitChanges"
    />
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'

const emit = defineEmits(['input'])

const filtersStore = useFiltersStore()

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const emitChanges = (isEnabled: boolean) => {
  filtersStore.updateUnsavedFilters({
    isHighRating: isEnabled || undefined,
  })
  emit('input', filtersStore.unsavedFilters)
}

const handleSwitch = () => {
  emitChanges(!filtersStore.unsavedFilters.isHighRating)
}
</script>
